// Scroll to element on the page when clicking a scrollable link
! (() => {
    let gtcLinks = document.querySelectorAll('[go-to-content]');
    if (gtcLinks.length === 0) return;

    /**
     * Scrolls to an element with navbar offset
     */
    const scrollto = (el) => {
        let navbar = document.querySelector('#navbar')
        let offset = navbar.offsetHeight

        let elementPos = document.querySelector(el).offsetTop
        window.scrollTo({
            top: elementPos - offset,
            behavior: 'smooth'
        })
    }

    /**
     * Handle click events on go-to-content elements
     */
    gtcLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // Only prevent default if we can find the target element
            let targetId = this.getAttribute('href');
            
            // Check if the href contains a hash
            if (targetId && targetId.includes('#')) {
                // Extract the hash part (everything after the #)
                let hash = targetId.substring(targetId.indexOf('#'));
                
                // If we can find the target element
                if (document.querySelector(hash)) {
                    e.preventDefault();
                    scrollto(hash);
                }
            }
        });
    });
})();